// @flow
import * as React from 'react';

import useLatest from './useLatest';

/**
 * Calls the callback function when the value changes.
 */
const useWatch = <T>(value: T, callback: () => void) => {
    const callbackRef = useLatest(callback);
    // Setting initial value to avoid first time callback call without any change.
    const previousValueRef = React.useRef(value);

    React.useEffect(() => {
        if (previousValueRef.current !== value) {
            callbackRef.current();
        }

        previousValueRef.current = value;
    }, [callbackRef, value]);
};

export default useWatch;
